module.exports = __webpack_public_path__ + "img/mohodata.a6590b13.svg";